import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import ReactSelect from "react-select";
import {
  AdminEmployeeActiveList,
  DirectorPerformanceReportFilter,
  GetDirectorPerformanceReportList,
  GetDirectorReportEmployee,
  HodEmployeeActiveList
} from "../../Repository/Api";
import { FinancialMonthOptions, FinancialYearOptions, FinancialYearView, IsOldReportYear, MonthView } from "../Common/FinancialYear";
import { errorMsg, successMsg } from "../Toastify";

const DirectorScoreReport = () => {
  const { first_name, department, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token
  const navigate = useNavigate();
  const { pathname } = useLocation()
  
  const initialApplyState = {
    employee_id: [],
    academic_year: [],
    months: [],
  };

  const [savedReport, setSavedReport] = useState({});
  const [filterReport, setFilterReport] = useState(initialApplyState);
  
  const [employee, setEmployee] = useState([]);
  useEffect(() => {
    getSavedReport();
    getEmployeeList();
  },[]);
  const setData = (e, key) => {
    
    setFilterReport({ ...filterReport, [key]: e });

  };

  const getEmployeeList = async () => {
    // const response = await GetDirectorReportEmployee(token);
    const response = pathname?.includes('Director') ? await GetDirectorReportEmployee(token) : pathname.includes('Hod') ? await HodEmployeeActiveList(token) : pathname?.includes('admin') && await AdminEmployeeActiveList(token)
    if (response && response.statusCode === 200) {
      
      let employee = pathname?.includes('Director') ?
        response?.data?.map((label) => ({
          label: label.name,
          value: label.id,
        })) :
        pathname?.includes('Hod') ?
          response?.data?.employee_details?.map((label) => ({
            label: label.first_name + ' ' + label.last_name,
            value: label.id,
          })) : pathname?.includes('admin') ?
            response?.data?.employee_details?.map((label) => ({
              label: label.first_name + ' ' + label.last_name,
              value: label.id,
            })) : ''
      setEmployee(employee);
    } else {
      errorMsg(response.message);
    }
  };
  const getSavedReport = async () => {
    const response = await GetDirectorPerformanceReportList(token);
    if (response && response.statusCode === 200) {
      setSavedReport(response?.data?.report);
    } else {
      errorMsg(response.message);
    }
  };
  const getFilterReport = async () => {
    let getemployee = filterReport?.employee_id?.value;
    let getyear = filterReport?.academic_year;
    let getmonth = filterReport?.months?.value;

    const response = await DirectorPerformanceReportFilter(
      getemployee,
      getyear,
      getmonth,
      token
    );
    if (response && response.statusCode === 200) {
      setSavedReport(response?.data?.report);
      successMsg(response.message);
    } else {
      errorMsg(response.message);
    }
  };

  return (
    <>
      <div className="">
        <section className="top-content-container">
          <div className="my-4">
            <div className="row">
              <div className="col-lg-6">
              <h6 className="headertext">{first_name}</h6>
                <h6 className="subheadertext">{department}</h6>
              </div>
              <div className="col-lg-6">
                <div className="headeralign">
                  <button
                    className="requestbtn"
                    onClick={() => {
                      navigate(
                        pathname?.includes('Director') ?
                          "/app/Director/DirectorScoreReportGenerate" :
                          pathname?.includes('Hod') ?
                            '/app/Hod/HodScoreReportGenerate' :
                            pathname?.includes('admin') ?
                              '/app/admin/AdminScoreReportGenerate' : ''
                      );
                    }}
                  >
                    Generate Performance Report
                  </button>
                </div>
              </div>
            </div>
          </div>
        </section>
        <section>
          <div className="row">
            <div className="">
              <div className="graphbox">
                <h6 className="labeltitle">Perfomance Report Status</h6>
                <div className="row mt-3">
                  <div className="col-lg-10">
                    <div className="row">
                      <div className="col-lg-4">
                        <label className="labeltext">Employee</label>
                        <ReactSelect
                          isMulti={false}
                          value={filterReport?.employee_id}
                          onChange={(e) => {
                            setData(e, "employee_id");
                          }}
                          options={employee}
                        />
                      </div>
                      <div className="col-lg-4">
                        <label className="labeltext">Select a Year</label>
                        <ReactSelect
                          isMulti={false}
                          value={{
                            label: filterReport.academic_year,
                            value: filterReport.academic_year,
                          }}
                          onChange={(selectedOption) =>
                            setData(selectedOption.value, "academic_year")
                          }
                          options={FinancialYearOptions()}
                        />
                      </div>
                      {!IsOldReportYear(filterReport) && (
                        <div className="col-lg-4">
                          <div className="mb-3">
                            <label className="labeltext">Select Month</label>
                            <ReactSelect
                              value={filterReport?.months}
                              onChange={(e) => {
                                setData(e, "months");
                              }}
                              options={
                                FinancialMonthOptions(filterReport)
                              }
                            />
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-1 mt-auto">
                    <div className="row">
                      <div className="col-lg-3 mt-auto">
                        <div className="mb-3">
                          <button
                            type="button"
                            className="requestbtn"
                            onClick={getFilterReport}
                          >
                            Search
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <table className="table table-hover mt-4">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Department</th>
                      <th scope="col">Month</th>
                      <th scope="col">Year</th>
                      <th scope="col">Application</th>
                    </tr>
                  </thead>
                  <tbody>
                    {savedReport?.length > 0 ? (
                      savedReport &&
                      savedReport?.map((saved, index) => (
                        <tr key={index}>
                          <td>{saved?.name ? saved?.name : "-"}</td>
                          <td>{saved?.department ? saved?.department : "-"}</td>
                          <td>{saved?.month ? MonthView(saved?.month) : "-"}</td>
                          <td>
                            {saved?.academic_year ? FinancialYearView(saved?.month, saved?.academic_year) : "-"}
                          </td>
                          <td className="viewoption">
                            <Link
                              to={
                                pathname.includes('Director') ?
                                  `/app/Director/DirectorScoreReportSpecificview/${saved?.id}` :
                                  pathname.includes('Hod') ?
                                    `/app/Hod/HodScoreReportSpecificview/${saved?.id}` :
                                    pathname.includes('Admin') ?
                                      `/app/admin/AdminScoreReportSpecificview/${saved?.id}` : ''
                              }
                            >
                              View
                            </Link>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <>
                        <tr>
                          <td></td>
                          <td></td>
                          <td>
                            <div> No Data Found</div>
                          </td>
                          <td></td>
                          <td></td>
                        </tr>
                      </>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default DirectorScoreReport;
